import Vue from 'vue';
import { RouteConfig } from 'vue-router';

import { RoutesType, PublicRoutes, AuthorizedRoutes } from '@/entries/user/router/AppRouteConfig';

export default Vue.extend({
  name: 'RoutesMixin',

  data(): {
    routes: RoutesType;
  } {
    return {
      routes: {
        ...PublicRoutes,
        ...AuthorizedRoutes,
      },
    };
  },

  methods: {
    openRoute(route: RouteConfig) {
      const link = this.$router.resolve({
        name: route.name,
        params: this.$route.params,
      });
      window.open(link.href, '_blank');
    },
  },
});
